import { useCallback } from 'react';

import Tooltip from '@mui/material/Tooltip';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';

import type { FileItem } from './types/file-item.type';

interface RenameActionProps {
  readonly file: FileItem;
  readonly onRename: (file: FileItem) => void;
}

export const RenameAction = ({
  file,
  onRename,
}: Readonly<RenameActionProps>) => {
  const handleClick = useCallback(() => {
    onRename(file);
  }, [file, onRename]);

  const actionLabel = 'Renommer';

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={actionLabel}>
          <DriveFileRenameOutlineIcon fontSize="inherit" />
        </Tooltip>
      }
      label={actionLabel}
      onClick={handleClick}
    />
  );
};
